module.exports = __webpack_public_path__ + "static/img/carte-laptop.dbe32a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/carte-laptop.jpg
// module id = FK1y
// module chunks = 1